import {
  CloseButton,
  Drawer,
  Flex,
  HStack,
  Icon,
  Portal,
  Text,
  VStack,
} from '@chakra-ui/react';
import { LuLandmark } from 'react-icons/lu';
import { SidebarNav } from './SidebarNav';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function MobileNav({ open, onOpenChange }: Props) {
  return (
    <Drawer.Root
      open={open}
      onOpenChange={(e) => onOpenChange(e.open)}
      placement="start"
      size="xs"
    >
      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content bg="bg.surface">
            <Drawer.Header borderBottomWidth="1px" borderColor="border" py="3" px="4">
              <HStack gap="2">
                <Flex
                  w="9"
                  h="9"
                  align="center"
                  justify="center"
                  rounded="lg"
                  bg="brand.500"
                  color="white"
                  shadow="sm"
                >
                  <Icon as={LuLandmark} boxSize="5" />
                </Flex>
                <VStack align="start" gap="0">
                  <Text fontWeight="700" lineHeight="1.1" fontSize="md">
                    CrediFacilGT
                  </Text>
                  <Text fontSize="xs" color="fg.muted">
                    Lotificadora
                  </Text>
                </VStack>
              </HStack>
            </Drawer.Header>
            <Drawer.Body px="3" py="4">
              <SidebarNav onNavigate={() => onOpenChange(false)} />
            </Drawer.Body>
            <Drawer.CloseTrigger asChild>
              <CloseButton size="sm" position="absolute" top="3" insetEnd="3" />
            </Drawer.CloseTrigger>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  );
}
